export const NEXT_PUBLIC_GOOGLE_MAPS_API_KEY = 'AIzaSyBQY2s1FjOqhhUTwytUScD0gvLgz3oQUK4'
export const NEXT_PUBLIC_RECAPTCHA_SECRET_AK_V3 = '6Ldj-KgUAAAAAMNADaTxy87S55reA5m5BMeg1m1u'

export const Emali_reg = new RegExp(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/)

export const us_phone_reg = new RegExp(/^\(?[0-9]{3}\)?[0-9]{3}-?[0-9]{4}$/)

export const cn_phone_reg = new RegExp(/^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/)

export const loading_mp4 = 'https://assets5.month2month.us/assets/h_loader-07bfc65c1cdcc7f033faf73259a52c1faa93e8bff6a4e87c437f267831e33321.webm'

export const Home_Contacts = [
    '(949)-438-0617 for business',
    '(949)-288-6628 for customer services',
    'booking@month2month.com',
    '20 Corporate Park, Suite 100, Irvine CA 92606'
]
